import React, {useState, useEffect} from "react";

import styles from "./App.module.css";

import FileUpload from "./components/UI/FileUpload";
import Button from "./components/UI/Button";

import {useForm} from "./components/Hooks/form-hook";

const CONTENT_TYPES = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
};

function App() {
  const [file, setFile] = useState(null);
  const [contactId, setContactId] = useState(null);
  const [isProcessComplete, setIsProcessComplete] = useState({
    state: false,
    message: "",
  });
  const [uploadFormState, uploadInputHandler] = useForm(
    {
      file: {
        value: null,
        isValid: false,
      },
    },
    false,
  );

  const uploadSubmitHandler = async (event) => {
    event.preventDefault();

    const fileValue = uploadFormState.inputs.file.value;
    const ext = fileValue?.name.split(".").pop()?.toLowerCase();
    const contentType = CONTENT_TYPES[ext] ?? "application/pdf";

    uploadInputHandler("file", null, false);
    setFile(null);
    setIsProcessComplete({state: false, message: "Uploading....."});

    try {
      console.log(`Requesting presigned URL for: ${fileValue.name} (${contentType})`);
      const urlResp = await fetch(
        `${process.env.REACT_APP_AWS_ENDPOINT}/get-upload-url`,
        {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({
            contact_id: contactId,
            fileName: fileValue.name,
            contentType,
          }),
        },
      );

      if (!urlResp.ok) {
        throw new Error(`Failed to get upload URL: ${urlResp.status}`);
      }

      const {url} = await urlResp.json();

      console.log(`Uploading file directly to S3`);
      const uploadResp = await fetch(url, {
        method: "PUT",
        headers: {"Content-Type": contentType},
        body: fileValue,
      });

      if (!uploadResp.ok) {
        throw new Error(`Upload failed: ${uploadResp.status}`);
      }

      setIsProcessComplete({state: true, message: "Upload complete!"});
    } catch (error) {
      console.log(`Error in uploading file =======> ${error.message}`);
      setIsProcessComplete({
        state: false,
        message: "Upload failed, please try again!",
      });
    }
  };

  useEffect(() => {
    const contact_id = new URLSearchParams(window.location.search).get(
      "contact_id",
    );
    console.log(`Contact ID  =====>  ${contact_id}`);
    if (contact_id) {
      setContactId(contact_id);
    }
  }, []);

  return (
    <div className={`${styles.App}`}>
      <div className={`${styles.App__header}`}>
        <img src="images/ccx_logo.png" alt="Community ConnectX logo" />
      </div>
      <div className={`${styles.App__section}`}>
        <div className={`${styles.App__Upload__Container}`}>
          <div className={`${styles.App__Header}`}>
            <p>
              You may qualify for a work requirement waiver. Please upload
              documentation to prove your condition.
            </p>
            <p>For example:</p>
            <p>
              1. A letter or form from a healthcare provider that says you have
              condition that limits work or daily functioning
            </p>
            <p>
              2. A disability determination notice from Social Security (SSI or
              SSDI), VA, or long-term disability insurance{" "}
            </p>
            <p>
              3. Medical records or discharge summaries that describe a serious
              or chronic condition (e.g. cancer treatment, ESRD, mental illness)
            </p>
            <p>
              4. Enrollment in a program that supports people with serious
              health conditions like the Arizona Long Term Care System (ALTCS),
              or certain Medicaid managed care plans
            </p>
          </div>
          <div className={`${styles.App__Upload}`}>
            <div
              className={`${styles.App__Upload__Segment}`}
              style={{
                border: "1px solid #cbd5e1",
                borderRadius: "10px",
                padding: "2rem 0",
              }}
            >
              <FileUpload
                id="file"
                onInput={uploadInputHandler}
                disabled={isProcessComplete.state}
                file={file}
                accept=".pdf,.png,.jpg,.jpeg"
                setFileName={(filename) => {
                  setFile(filename);
                }}
              />
            </div>
            <div className={`${styles.App__Upload__Segment}`}>
              <Button
                type="submit"
                size="quarter"
                disabled={!uploadFormState.isValid || isProcessComplete.state}
                onClick={uploadSubmitHandler}
              >
                Upload
              </Button>
            </div>
            <div className={`${styles.App__Upload__Segment}`}>
              {isProcessComplete.message && (
                <h6 style={{color: "#1b4b8d"}}>{isProcessComplete.message}</h6>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
